import { store } from '../../store'
import { httpgst } from '../../main'

// actions
const actions = {
  getTemplate ({ commit, dispatch }, payload) {
    let url = `api/expensesAmex/downloadLayoutAmex`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let params = {
      responseType: 'blob'
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, params, options)
      .then(
        response => {
          commit('onGetTemplate', {event: payload.event, response: response})
        },
        error => {
          commit('onGetTemplateError', {event: payload.event, error: error})
        }
      )
  },
  get ({commit, dispatch}, payload) {
    let url = 'api/petty-cash/by-company/' + store.state.userLogged.company[0].id + '?type=1'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  post ({commit, dispatch}, payload) {
    let cardNumber = null
    if (payload.event.item.user.card_number !== null) {
      cardNumber = payload.event.item.user.card_number
    } else if (payload.event.item.user.card_number2 !== null) {
      cardNumber = payload.event.item.user.card_number2
    }
    let url = 'api/petty-cash'
    let params = {
      'core_user_id': payload.event.item.core_user_id,
      'period_start_date': new Date().toISOString().split('T')[0],
      'period_end_date': '2100-01-01',
      'description': payload.event.item.description,
      'card_number': undefined,
      'type': 1
    }

    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  addCash ({commit, dispatch}, payload) {
    let url = 'api/petty-cash-detail'
    let params = {
      'user_id': payload.event.item.core_user_id,
      'amount': payload.event.item.cash,
      'description': payload.event.item.description,
      'transaction_date': payload.event.item.transaction_date ? payload.event.item.transaction_date : undefined,
      'is_payment': payload.event.item.is_payment,
      'small_box_id': payload.event.item.small_box_id
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {})
      .then(
        response => {
          commit('onAddCash', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  put ({commit, dispatch}, payload) {
    let url = 'api/petty-cash/' + payload.event.item.id
    let params = {
      'type': 1,
      'period_start_date': payload.event.item.period_start_date !== '' ? payload.event.item.period_start_date : undefined,
      'period_end_date': payload.event.item.period_end_date !== '' ? payload.event.item.period_end_date : undefined,
      'description': payload.event.item.description,
      'card_number': payload.event.item.user.card_number !== null ? payload.event.item.user.card_number : undefined
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {})
      .then(
        response => {
          commit('onPut', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  deletePetty ({commit, dispatch}, payload) {
    let url = `api/petty-cash/${payload.event.item.id}/${payload.event.item.core_user_id}`
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {})
      .then(
        response => {
          commit('onDeletePetty', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  downloadGeneralHistory ({commit, dispatch}, payload) {
    let url = 'api/petty-cash-company/' + store.state.userLogged.company[0].id
    let params = {
      type: 'download',
      petty_cash_type: 1
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params: params, responseType: 'blob' })
      .then(
        response => {
          commit('onDownloadGeneral', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  // GET api/petty-cash-user-detail/company?type=download&box_type=1&start_date&end_date&user_id
  // Detalle de caja chica de toda la empresa acotado al mes elegido en la vista.
  // type y box_type van fijos: siempre es descarga de caja chica (box_type 1).
  // user_id es opcional (lista separada por comas); undefined lo omite de la
  // query y el endpoint responde con todos los usuarios.
  // Se deja aparte de downloadGeneralHistory, que apunta a otro endpoint.
  downloadCompanyDetail ({commit, dispatch}, payload) {
    let url = 'api/petty-cash-user-detail/company'
    let params = {
      type: 'download',
      box_type: 1,
      start_date: payload.event.start_date,
      end_date: payload.event.end_date,
      user_id: payload.event.user_id
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params: params, responseType: 'blob' })
      .then(
        response => {
          commit('onDownloadCompanyDetail', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  // GET api/petty-cash-request/report?start_date&end_date&user_id
  // Reporte de solicitudes de caja chica. Toma el mismo mes y los mismos
  // usuarios de la vista; no recibe type ni box_type.
  downloadRequestReport ({commit, dispatch}, payload) {
    let url = 'api/petty-cash-request/report'
    let params = {
      start_date: payload.event.start_date,
      end_date: payload.event.end_date,
      user_id: payload.event.user_id
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params: params, responseType: 'blob' })
      .then(
        response => {
          commit('onDownloadRequestReport', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  downloadUserHistory ({commit, dispatch}, payload) {
    let url = 'api/petty-cash-user-detail/' + payload.event.user
    let params = {
      type: 'download',
      box_type: 1
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params: params, responseType: 'blob' })
      .then(
        response => {
          commit('onDownloadUser', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  postMassiveCreate ({ commit, dispatch }, payload) {
    let url = `/api/expensesAmex/insertLayoutData`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const items = []
    payload.event.items.forEach(el => {
      items.push(el.row)
    })

    let params = items
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, options)
      .then(
        response => {
          commit('onPostMassiveCreate', {event: payload.event, response: response})
        },
        error => {
          commit('onPostMassiveCreateError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {
  onGetTemplate (state, payload) {
    payload.event.context.forceFileDownload(payload.response.data, 'AMEXLayout.xlsx')
    payload.event.context.loading = false
  },
  onGetTemplateError (state, payload) {
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
  },
  onGet (state, payload) {
    let pettyCash = payload.response.data.data[0].users
    
    const pettyCashFilter = pettyCash.filter(user =>
      user.small_box.some(box => box.type === 1)
    )
    
    pettyCashFilter.forEach(pettyCash => {
      let pettyCashObj = pettyCash.small_box.find(box => box.type === 1)
      pettyCash.period_start_date = pettyCashObj.period_start_date
      pettyCash.period_end_date = pettyCashObj.period_end_date
      pettyCash.description = pettyCashObj.description
      pettyCash.amount = pettyCashObj.amount
    })

    payload.event.context.pettyCash = pettyCashFilter

    payload.event.context.loadingItems = false
  },
  onPost (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    let event = payload.event
    event.item = {
      core_user_id: payload.event.item.core_user_id,
      cash: payload.event.item.amount,
      description: payload.event.item.description,
      transaction_date: new Date().toISOString().substr(0, 10),
      is_payment: true,
      small_box_id: payload.response.data.data.id
    }
    payload.event.context.viewCardNumberTxt = true
    this.dispatch('pettyCash/addCash', { event: event })
    // payload.event.context.close()
    // payload.event.context.refresh()
  },
  onPut (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.refresh()
  },
  onAddCash (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.refresh()
  },
  onDownloadGeneral (state, payload) {
    payload.event.context.loading3 = false
    payload.event.context.forceFileDownload(payload.response.data, `GeneralPettyCashHistory ${new Date().toISOString().substr(0, 10)}.xlsx`)
  },
  onDownloadCompanyDetail (state, payload) {
    payload.event.context.loading3 = false
    payload.event.context.forceFileDownload(payload.response.data, `CompanyPettyCashDetail ${payload.event.start_date} ${payload.event.end_date}.xlsx`)
  },
  onDownloadRequestReport (state, payload) {
    payload.event.context.loading4 = false
    payload.event.context.forceFileDownload(payload.response.data, `PettyCashRequests ${payload.event.start_date} ${payload.event.end_date}.xlsx`)
  },
  onDownloadUser (state, payload) {
    payload.event.context.loading2 = false
    payload.event.context.forceFileDownload(payload.response.data, `UserPettyCashHistory ${new Date().toISOString().substr(0, 10)}.xlsx`)
  },
  onDeletePetty (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.refresh()
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
      payload.event.context.loading = false
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
    payload.event.context.loading2 = false
    payload.event.context.loading3 = false
    payload.event.context.loading4 = false
  },
  onPostMassiveCreate (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeBatch()
  },
  onPostMassiveCreateError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.itemsBatchErrors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
  }
}

export default {
  namespaced: true,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/pettyCash.js